<template>
  <div>
    <div class="uk-cover-container">
      <BannerComponent :banner-url="`${ASSETS_BASE_URL}/images/about-us/about.jpg`" :title="'about_us' | translate"/>
    </div>
    <div class="uk-container SectionOne">
      <p class="uk-text-center Description">
        {{'about_us_view.para_1'|translate}}
        <br/>
        <br/>
        {{'about_us_view.para_2'|translate}}
        <br/>
        <br/>
        {{'about_us_view.para_3'|translate}}
      </p>

      <OurCollectionComponent/>

      <!--Map-->
      <ContactInfoComponent :embedded-map-url="embeddedMapUrl"/>
      <!--Partners-->
      <OurPartners class="SectionOne" :logos="logos"/>

    </div>
  </div>
</template>

<script>
import BannerComponent from '../components/BannerComponent'
import ContactInfoComponent from '../components/about-us/ContactInfoComponent'
import OurPartners from '../components/about-us/OurPartnersComponent'
import store from '../store'
import OurCollectionComponent from '../components/OurCollectionComponent'

export default {
  name: 'Properties',
  components: {
    OurCollectionComponent,
    BannerComponent,
    ContactInfoComponent,
    OurPartners
  },
  data: function () {
    return {
      embeddedMapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d990.2755633365402!2d79.87915932922544!3d6.878351631141801!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae25a35fcb985c9%3A0x18e14b537b711c16!2s21%20Siebel%20Ave%2C%20Colombo%2000500!5e0!3m2!1sen!2slk!4v1571553100066!5m2!1sen!2slk',
      logos: store.state.about.logos
    }
  }
}
</script>

<style scoped>
  .SectionOne {
    padding-top: 30px;
    padding-bottom: 80px;
  }

  .Title {
    padding-top: 25px;
    font-family: 'Kaushan Script', cursive !important;
  }

  .Description {
    font-size: 18px;
  }
</style>
